export const enum AppDom {
  auth = 'auth',
}
